import { createSlice } from '@reduxjs/toolkit';

// Sentinel used as `selectedPlaylistId` when the source is the user's
// Liked Tracks rather than a real playlist. Kept distinct from any real
// playlist id (cloud ids are UUIDs, local ids are numbers) so equality
// checks in the thunk/UI can branch on it safely.
export const LIKES_SOURCE_ID = '__mixgoat_likes__';

const smartRecsSlice = createSlice({
    name: 'smartRecs',
    initialState: {
        selectedPlaylistId: null,
        isLoading: false,
        error: null,
        results: null,
        variant: 'A',
    },
    reducers: {
        setSelectedPlaylist: (state, action) => {
            state.selectedPlaylistId = action.payload;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setResults: (state, action) => {
            state.results = action.payload;
        },
        setVariant: (state, action) => {
            state.variant = action.payload;
        },
        clearResults: (state) => {
            state.results = null;
            state.error = null;
        },
    },
});

export const {
    setSelectedPlaylist,
    setLoading,
    setError,
    setResults,
    setVariant,
    clearResults,
} = smartRecsSlice.actions;

export default smartRecsSlice.reducer;
